import AdministrativeTasksModule from '@pages/administrativeTasks/AdministrativeTasksModule'
import AdministrativeTasksIndex from '@pages/administrativeTasks/Index.vue'

export default {
    path: 'administrative-tasks',
    component: AdministrativeTasksModule,
    children: [
        {
            path: '/',
            component: AdministrativeTasksIndex,
            name: 'administrativeTasksIndex',
        },
    ],
}
